import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { SelectedRouteReportSummary } from '@src/app/interfaces/route-stats.interface';

@Component({
  selector: 'app-route-summary-data',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './route-summary-data.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./route-summary-data.component.scss'],
})
export class RouteSummaryDataComponent {
  @Input() public data: SelectedRouteReportSummary[] = [];
}
